import { useMutation } from 'react-query'

import { ErrorResponse } from 'services/error-response'
import httpClient from 'services/http-client'

import { GET_ALL_FAVOURITE_PRODUCTS } from './use-get-all-favourite-products'

const setFavouriteProduct = async (key: string) =>
  httpClient.put(GET_ALL_FAVOURITE_PRODUCTS, {
    key,
  })

export const usePutFavouriteProduct = (onSuccess: () => void, onError: (data: ErrorResponse) => void) =>
  useMutation(setFavouriteProduct, {
    onSuccess,
    onError,
  })
